import { NOCD_BILLING_EMAIL, NOCD_CARE_TEAM_EMAIL } from "@core/constants";
import Container from "@core/layout/Container";
import Button from "@core/ui/Button";
import BaseCard from "@core/ui/Card";
import { MailIcon } from "@heroicons/react/solid";
import React, { FC } from "react";

import Footer from "../components/Footer";

const Card: FC<{ title: string; className?: string }> = ({
  title,
  className,
  children,
}) => {
  return (
    <BaseCard variant="outlined" rounded="xl" className={className}>
      <div className="mb-6">
        <h2 className="text-lg font-bold text-gray-900 phone:text-2xl">
          {title}
        </h2>
      </div>
      {children}
    </BaseCard>
  );
};

const ContactInfo: FC<{ message?: string; email: string }> = ({
  message,
  email,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2.5">
        <MailIcon className="h-5 w-5 text-indigo-600" />
        <span className="space-x-2">
          <strong>Email:</strong>
          <a className="text-teal-600" href={`mailto:${email}`}>
            {email}
          </a>
        </span>
      </div>
      {message && (
        <div>
          <div className="flex items-center space-x-2.5">
            <MailIcon className="h-5 w-5 text-indigo-600" />
            <span className="space-x-2">
              <strong>Message:</strong>
              <a
                className="text-teal-600"
                href={`${process.env.NEXT_PUBLIC_NOCD_API_BASE_URL}/link/member_advocate_chat`}
              >
                {message}
              </a>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const SupportPage: FC = () => {
  return (
    <div className="space-between flex w-full max-w-full flex-col">
      <Container
        className="mb-18 mt-18 max-w-[850px] text-gray-900"
        disableMaxWidth
      >
        <div className="mb-16">
          <div className="mb-8">
            <h1 className="text-2xl font-bold phone:text-4xl">
              How can we help?
            </h1>
          </div>
          <div className="grid grid-cols-1 gap-8 phone:grid-cols-2">
            <Card title="Support">
              <ContactInfo
                email={NOCD_CARE_TEAM_EMAIL}
                message="Our Member Advocates"
              />
            </Card>

            <Card title="Billing">
              <ContactInfo email={NOCD_BILLING_EMAIL} />
            </Card>

            <Card title="Emergency resources" className="phone:col-span-2">
              <div>
                <p>
                  If you or someone you know is struggling or in crisis, help is
                  available. Call or text 988 or chat{" "}
                  <a
                    href="http://988lifeline.org"
                    className="text-teal-600 underline"
                  >
                    988lifeline.org
                  </a>
                  . If you are experiencing an emergency, please call 911.
                </p>
              </div>
            </Card>
          </div>
        </div>
        <div className="flex flex-col items-center space-y-6">
          <h3 className="px-8 text-center text-2xl font-bold phone:px-0">
            Can&apos;t find what you&apos;re looking for?
          </h3>
          <Button
            as="a"
            href={`${process.env.NEXT_PUBLIC_WEBSITE_BASE_URL}/about-us/contact-us`}
            className="inline-flex items-center justify-center py-3 px-6"
            rounded="lg"
            disablePadding
          >
            <span>Submit a request</span>
          </Button>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default SupportPage;
